import {TextStyle, ViewStyle} from 'react-native';

export const styles = {
  container: {
    flex: 1,
    paddingTop: 0,
    marginTop: 0,
  } as ViewStyle,
  item: {
    paddingTop: 15,
    paddingLeft: 5,
    fontSize: 12,
    height: 160,
    color: 'black',
    width: 80,
  } as ViewStyle,
  tinyLogo: {
    marginTop: 2,
    width: 22,
    height: 22,
  } as ViewStyle,
  scroll: {
    height: 65,
    display: 'flex',
    position: 'relative',
    backgroundColor: 'black',
    width: '100%',
    marginTop: 0,
  } as ViewStyle,
  icon: {
    paddingLeft: 10,
  } as TextStyle,
};
